import React, { useEffect, useMemo, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import {
  getUploadedFileStart,
  uploadFileStart,
  deleteFileStart,
  deleteFileReset,
} from "store/actions"
//import { CustomerNo } from "../CustomerListCol"
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from "reselect"
import { Card, CardBody } from "reactstrap"
import DeleteModal from "components/Common/DeleteModal"
import { useParams } from "react-router-dom"
///delete-file
const FileTable = () => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const { isUploading, Loading, deleteFile } = useSelector(
    state => state.CustomerReducer
  )

  const { refFilesList, loading, responseMsg } = useSelector(
      state => state.ReferenceReducer
    )
  
  function getFileExtension(filename, url) {
    if (filename) {
      const ext = filename.split(".").pop()

      if (ext.toLowerCase() === "pdf") {
        return (
          <div className="">
            <i className="mdi mdi-file-pdf fs-1 text-danger"></i>
          </div>
        )
      } else if (ext.toLowerCase() === "docx") {
        return (
          <div className="">
            <i className="mdi mdi-file-document fs-1 text-primary"></i>
          </div>
        )
      } else if (
        ext.toLowerCase() === "jpeg" ||
        ext.toLowerCase() === "png" ||
        ext.toLowerCase() === "jpg"
      ) {
        return (
          <div className="">
            <img src={url} width={"70px"} />
          </div>
        )
      } else if (ext.toLowerCase() === "csv" || ext.toLowerCase() === "xlsx") {
        return <i className="mdi mdi-file-excel fs-1 text-primary"></i>
      } else {
        return <i className="mdi mdi-file fs-1"></i>
      }
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: (row, i) => i + 1,
        filterable: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Preview",
        accessor: row => ({
          File_name: row.file_name,
          url: row.File,
        }),
        filterable: true,
        Cell: cellProps => {
          const { File_name, url } = cellProps.value
          return (
            <>
              <a href={url} download>
                {getFileExtension(File_name, url)}{" "}
              </a>
            </>
          )
        },
      },
      {
        Header: "File Name",
        accessor: "file_name",
        filterable: true,
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: () => {
          return <div className="text-center">Actions</div>
        },
        accessor: "File",
        filterable: true,
        Cell: cellProps => {
          console.log(cellProps)
          return (
            <div className="d-flex justify-content-center align-items-center p-3 border rounded shadow-sm">
              <a
                href={cellProps.value}
                download
                className="btn btn-outline-primary me-2"
              >
                Download
              </a>
            </div>
          )
        },
      },
    ],
    []
  )


  console.log(deleteFile)
  return (
    <>
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">References Files</h4>
          <TableContainer
            columns={columns}
            data={refFilesList?.files || [] || []}
            isGlobalFilter={false}
            isAddOptions={false}
            //handleJobClicks={handleJobClicks}
            isJobListGlobalFilter={false}
            isPagination={true}
            iscustomPageSizeOptions={false}
            isShowingPageLength={true}
            customPageSize={10}
            tableClass="table-bordered align-middle nowrap mt-2"
            paginationDiv="col-sm-12 col-md-7"
            pagination="pagination justify-content-end pagination-rounded"
          />
        </CardBody>
      </Card>
    </>
  )
}

export default FileTable
